import { UserList } from '@unistocks/features/admin/components/user-management/user-list';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function UserManagementScreen() {
  return (
    <>
      <Head>
        <title>{t('AbpIdentity::Users')}</title>
      </Head>
      <UserList />
    </>
  );
}
